import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AppAuthModule)
  },
  {
    path: 'cases',
    loadChildren: () => import('./cases/case.module').then(m => m.CaseModule)
  },
  {
    path: 'clients',
    loadChildren: () => import('./clients/client.module').then(m => m.ClientModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'depositions',
    loadChildren: () => import('./depositions/deposition.module').then(m => m.DepositionModule)
  },
  {
    path: '',
    component: DashboardComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
